module.exports = __webpack_public_path__ + "assets/img/32_646_big.21ff9320.jpg";